import { Box, Grid } from '@mui/material';
import React from 'react';

import useAncapRecord from '@/hooks/use-ancap-record';
import { ExtraSmall, H5, Small } from '@/components/type';
import { LOCALSTORAGE_KEYS, RATERS } from '@/constants';
import CardImage from '@/components/card-image';
import CloseIcon from '@/components/icons/close-icon';
import StarRating from '@/components/star-rating';
import getIsZeroStarAncapRating from '@/utils/get-is-zero-star-ancap-rating';
import { STAR_PLACEMENT } from '@/components/star-rating/constants';

import { RemoveLink, StyledVehicleCard } from './styles';
import { getPriceGuideCopy } from '@/utils/get-relevant-price-for-vehicle';
import { type VehicleSearchResult } from '@tac/vehicle-api-client/types';
import { generateRedbookImageUrl } from '@/utils/get-redbook-image';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'vehicleId' implicitly has an 'any' type.
const removeVehicleFromCart = (vehicleId, removeFromCompareAction) => {
  if (vehicleId) {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      try {
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Argument of type 'never[]' is not assignable to parameter of type 'string'.
        localStorage.setItem(LOCALSTORAGE_KEYS.COMPARE, []);
      } catch (e) {
        // localStorage is disabled
        console.error('Failed to remove vehicle from compare', e);
      }
    }
  }
  removeFromCompareAction(vehicleId);
};

type MiniCartItemProps = {
  vehicle: VehicleSearchResult;
  removeFromCompare: (redbookCode: string) => void;
};

const MiniCartItem = ({ vehicle, removeFromCompare }: MiniCartItemProps) => {
  const {
    makedescription: makeDescription,
    modeldescription: modelDescription,
    vehicleid: redbookCode,
    description: vehicleDescription,
    year,
    activeratingprovider: selectedRating,
  } = vehicle;

  const ancapTestRecordResult = useAncapRecord(vehicle.vehicleid);
  const { data: ancapTestRecord } = ancapTestRecordResult;
  const { ratingYear } = ancapTestRecord;

  const image = generateRedbookImageUrl(vehicle.photoId ?? undefined);

  const isZeroStarAncapRating = getIsZeroStarAncapRating({
    makeDescription: vehicle.makedescription,
    modelDescription: vehicle.modeldescription,
    year: vehicle.year.toString(),
  });

  return (
    <StyledVehicleCard key={redbookCode}>
      <Grid container spacing={6}>
        <Grid item xs={4}>
          <CardImage src={image} alt={`${year} ${makeDescription} ${modelDescription}`} />
          {isZeroStarAncapRating ? (
            <>
              <StarRating stars={0} ratingBy="ANCAP" placement={STAR_PLACEMENT.COMPARISON_TILE} forceZeroStars />
            </>
          ) : (
            <>
              <StarRating
                stars={vehicle.stars ?? 0}
                ratingBy={selectedRating?.toUpperCase() == 'ANCAP' ? RATERS.ANCAP : RATERS.UCSR}
                placement={STAR_PLACEMENT.COMPARISON_TILE}
                testYear={ratingYear}
              />
              {selectedRating === RATERS.NO_CURRENT_RATING && <ExtraSmall>No current rating</ExtraSmall>}
              {selectedRating === RATERS.NO_RATING && <ExtraSmall>Not rated</ExtraSmall>}
            </>
          )}
        </Grid>
        <Grid item xs={8}>
          <RemoveLink onClick={() => removeVehicleFromCart(redbookCode, removeFromCompare)} tabIndex={0}>
            <CloseIcon />
            <Small>Remove</Small>
          </RemoveLink>
          <H5 as="h2">
            {makeDescription} {modelDescription}
          </H5>
          <Box mb={3}>
            <Small>
              {year} {vehicleDescription}
            </Small>
          </Box>
          <Small>
            {getPriceGuideCopy({
              privateMinPrice: vehicle.minprice,
              privateMaxPrice: vehicle.maxprice,
              newPrice: vehicle.minprice == vehicle.maxprice ? vehicle.maxprice : undefined,
            })}
          </Small>
        </Grid>
      </Grid>
    </StyledVehicleCard>
  );
};

export default MiniCartItem;
